import * as React from 'react';
import { IconArrowRight24 } from '@cian/ui-kit';

import * as style from './TopPromosContent.css';

export interface ITopPromosContentProps {
  title: string;
  label: string;
}

export const TopPromosContent: React.FC<ITopPromosContentProps> = props => {
  const { title, label } = props;

  return (
    <div className={style['container']} data-testid="TopPromosContent">
      <div className={style['label']}>{label}</div>
      <div className={style['title']}>{title}</div>
      <div className={style['button']}>
        <IconArrowRight24 color={'white_100'} />
      </div>
    </div>
  );
};
